import * as React from "react";
import IComDocType from "@components/IComDocType/IcomDocType";
import IcomBlock from "@components/Grid/IcomBlock";
import IComEditorGroup from "@components/IComEditorGroup/IComEditorGroup";
import IComCustomGridEditor from "@components/IComCustomGridEditor/IComCustomGridEditor";
import { Rte, RichTextFramed } from "@components/Grid/Rte";
import CategoryProducts from "@components/Grid/CategoryProducts";
import Embed from "@components/Grid/Embed";
import Textstring from "@components/Grid/Textstring";
import Media from "@components/Grid/Media";
import GridProducts from "@components/Grid/GridProducts"

export default class GridBaseEditor extends React.Component {

    constructor(props) {
        super(props);
        this.components = {
            textstring: Textstring,
            media: Media,
            rte: Rte,
            RichTextFramed: RichTextFramed,
            CategoryProducts: CategoryProducts,
            IcomBlock: IcomBlock,
            GridProducts: GridProducts,
            IComDocType: IComDocType,
            embed: Embed,
            icomEditorGroup: IComEditorGroup,
            Instagram: IComCustomGridEditor
        }
    }


    capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    render() {

        // Figure out view

        const serverRender = typeof window === 'undefined';
        const { control } = this.props;
        const viewName = control.editor.render != null ? control.editor.render : control.editor.view;
        const View = this.components[viewName];

        if (!View) {
            !serverRender && console.debug("Missing editor:", viewName);
            return ""; // No editor
        }
        //console.debug("GridBaseEditor - RENDER", viewName)

        //if (serverRender) {
        //    return (<View {...this.props} model={control} />);
        //}

        return (
            <View {...this.props} model={control} />
        );

    }
}
